export const round100 = (num: number) => {
  const arr = String(Math.round(num * 100) * 0.01).split('.')
  const float = arr[1] ? arr[1] : ''

  return Number(arr[0] + '.' + (float[0] || '') + (float[1] || ''))
}
